import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The management pages used to live under /:fundId/management/*. They moved to
 * the global management area (/management/*), so old bookmarks and deep links
 * (e.g. inquiry resource links carrying ?resourceId=) redirect to the new home.
 */
const LegacyManagementRedirect = () => {
  const params = useParams();
  const { search } = useLocation();

  return <Navigate to={`/management/${params['*'] ?? ''}${search}`} replace />;
};

export default LegacyManagementRedirect;
